import { render } from "./SmsGatewayComponent.vue?vue&type=template&id=264a2ec2"
import script from "./SmsGatewayComponent.vue?vue&type=script&lang=js"
export * from "./SmsGatewayComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/SmsGateway/SmsGatewayComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "264a2ec2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('264a2ec2', __exports__)) {
    api.reload('264a2ec2', __exports__)
  }
  
  module.hot.accept("./SmsGatewayComponent.vue?vue&type=template&id=264a2ec2", () => {
    api.rerender('264a2ec2', render)
  })

}


export default __exports__